import React, { useState } from 'react';
import { Modal } from './Modal';
import { Button } from './Button';
import { formatarData } from '../utils/helpers';

export const CancelamentoEscolhaModal = ({ show, onClose, escolha, handleConfirmarCancelamento }) => {
    const [motivo, setMotivo] = useState('');
    const [processing, setProcessing] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setProcessing(true);
        try {
            await handleConfirmarCancelamento(escolha, motivo);
            onClose();
        } catch (err) {
            setError(err.message || 'Falha ao processar o cancelamento.');
            setProcessing(false);
        }
    };

    return (
        <Modal show={show} onClose={() => !processing && onClose()} title="Cancelar Escolha de Cadete" size="md">
            {escolha && (
                <form onSubmit={handleSubmit} className="space-y-4">
                    <p className="text-gray-700">
                        Você está cancelando a escolha de **{escolha.cadete_nome}**
                        para **{escolha.local_nome}** no dia **{formatarData(escolha.data)}**.
                    </p>
                    <p className="text-sm text-red-700 bg-red-50 p-2 rounded-md font-semibold">
                        A escolha original será removida e uma entrada de "IMPOSSIBILIDADE" será criada para bloquear este dia. O cadete poderá escolher novamente (outro dia).
                    </p>
                    <div>
                        <label htmlFor="motivo" className="block text-sm font-medium text-gray-700">
                            Motivo do Cancelamento (Obrigatório)
                        </label>
                        <textarea
                            id="motivo"
                            rows="3"
                            value={motivo}
                            onChange={(e) => setMotivo(e.target.value)}
                            className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-lg shadow-sm"
                            placeholder="Ex: Atestado médico, cancelamento da vaga, etc."
                            required
                        ></textarea>
                    </div>

                    {error && <p className="text-red-600 mt-2 text-sm">{error}</p>}

                    <div className="flex justify-end gap-3 pt-4 border-t">
                        <Button onClick={() => onClose()} variant="secondary" disabled={processing}>
                            Voltar
                        </Button>
                        <Button type="submit" variant="danger" disabled={processing}>
                            {processing ? "Cancelando..." : "Confirmar Cancelamento"}
                        </Button>
                    </div>
                </form>
            )}
        </Modal>
    );
};
